import React, { useState } from "react";
import { Row, Col, Input, Button } from 'antd';
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { loginUserId } from "../../../_actions/user_actions";

function LoginPage(props) {

    const dispatch = useDispatch();

    const [UserId, setUserId] = useState("");
    const [Password, setPassword] = useState("");

    function respond_to_result(response) {
        const resdata = response.payload;
        console.log('resdata=', resdata);

        if (resdata.loginSuccess) {
            let message = ("Logged in successfully.");
            Swal.fire(("Success"), message, "success");
            props.history.push("/");
        } else {
            Swal.fire({ icon: "error", title: ("Oops..."), text: ('Something went wrong!!!') });
        }
    }

    function onChangeUserId(e){
        setUserId(e.target.value);
    }

    function onChangePassword(e){
        console.log(e.target.value);
        setPassword(e.target.value);
    }

    function onClickSignIn(){
        const dataToCommit = {user_id:UserId, password:Password};
        dispatch(loginUserId(dataToCommit)).then((response) => {
            respond_to_result(response);
        });

    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <div>
                <Row justify='center' align='middle' style={{margin:'40px'}}>
                    <Col style={{textAlign:'center', fontSize:'20px', fontWeight:'bold'}}>Please LogIn...</Col>
                </Row>
                <Row justify='center' align='middle' style={{margin:'20px'}}>
                    <Col span={8} style={{textAlign:'center'}}>ID:</Col>
                    <Col span={16}>
                        <Input onChange={onChangeUserId} placeholder="ID"/>
                    </Col>
                </Row>
                <Row justify='center' align='middle' style={{margin:'20px'}}>
                    <Col span={8} style={{textAlign:'center'}}>Password:</Col>
                    <Col span={16}>
                        <Input type="password" onChange={onChangePassword} onPressEnter={onClickSignIn}/>
                    </Col>
                </Row>
                <Row justify={'center'}  style={{margin:'10px'}}>
                    <Button onClick={onClickSignIn}>Sign In</Button>
                </Row>
            </div>
        </div>
    );
}

export default withRouter(LoginPage);
